import { Component, OnInit } from '@angular/core';
import { APP_SETTINGS } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {

  public nomeCliente = '';
  public parceiroComercial;

  constructor() {
    this.nomeCliente = APP_SETTINGS.nomeCliente;
    this.parceiroComercial = APP_SETTINGS.parceiroComercial;
  }

  ngOnInit() {
  }

}
